import { Button } from "@hortis/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@hortis/ui/dialog";
import type { ReactNode } from "react";

export const DiscardDialog = ({
  open,
  onOpenChange,
  onDiscard,
  children,
}: {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  onDiscard: () => void;
  children: ReactNode;
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    {children}
    <DialogContent data-cy="discard-dialog">
      <DialogHeader>
        <DialogTitle>Discard changes?</DialogTitle>
        <DialogDescription>
          Are you sure you want to discard your changes?
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <DialogClose asChild>
          <Button testId="discard-cancel-button">Cancel</Button>
        </DialogClose>
        <Button
          onClick={onDiscard}
          testId="discard-confirm-button"
          variant="warning"
        >
          Discard
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
